import { Action, Reducer } from 'redux';
import * as Actions from '../actions';
import {
  CreditorInvoicesState,
  CreditorInvoicesUnloadedState,
  creditorKey,
  emptyCreditorInvoicesEntry,
} from '../states/CreditorInvoicesState';
import { CreditorInvoicesEntry } from '../../models/Entities/CashFlow/CreditorInvoice/CreditorInvoice';

type KnownAction = Actions.CreditorInvoices.CreditorInvoicesKnownAction;

const withEntry = (
  state: CreditorInvoicesState,
  creditorId: string,
  update: (current: CreditorInvoicesEntry) => CreditorInvoicesEntry
): CreditorInvoicesState => {
  const key = creditorKey(creditorId);
  return { ...state, byCreditor: { ...state.byCreditor, [key]: update(state.byCreditor[key] ?? emptyCreditorInvoicesEntry()) } };
};

export const CreditorInvoicesReducer: Reducer<CreditorInvoicesState> = (
  state: CreditorInvoicesState | undefined,
  incomingAction: Action
): CreditorInvoicesState => {
  if (state === undefined) return CreditorInvoicesUnloadedState;
  const action = incomingAction as KnownAction;
  switch (action.type) {
    case 'CREDITOR_INVOICES_REQUEST_ACTION':
      // Se conserva la lista anterior mientras se vuelve a leer: la tabla no parpadea.
      return withEntry(state, action.creditorId, (current) => ({ ...current, status: 'loading', error: undefined }));
    case 'CREDITOR_INVOICES_RECEIVE_ACTION':
      return withEntry(state, action.creditorId, () => ({ status: 'loaded', data: action.invoices, error: undefined }));
    case 'CREDITOR_INVOICES_UNAVAILABLE_ACTION':
      return withEntry(state, action.creditorId, () => ({ status: 'unavailable', data: undefined, error: undefined }));
    case 'CREDITOR_INVOICES_FAIL_ACTION':
      return withEntry(state, action.creditorId, (current) => ({ ...current, status: 'failed', error: action.error }));
    case 'PAYMENT_INVOICES_COUNT_ACTION':
      return { ...state, invoiceCountByPayment: { ...state.invoiceCountByPayment, [action.paymentId]: action.count } };
    default:
      return state;
  }
};
